import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle } from 'lucide-react';

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqData = [
    {
      question: "Was kostet IT-Support für Unternehmen in Siegburg?",
      answer: "Unsere Managed IT-Services bieten transparente Preismodelle pro Arbeitsplatz/Monat und beinhalten proaktives Monitoring, regelmäßige Wartung, Software-Updates und telefonischen Support während der Geschäftszeiten. Für 24/7-Support und Vor-Ort-Service bieten wir individuelle Premium-Pakete an. Die genauen Kosten hängen von Ihrem spezifischen Bedarf, der Unternehmensgröße und gewünschten Service-Level ab. Eine kostenlose Erstberatung mit detailliertem Angebot ist selbstverständlich inklusive."
    },
    {
      question: "Wie schnell reagiert AB-Informatik bei IT-Notfällen?",
      answer: "Bei kritischen IT-Sicherheitsvorfällen und Systemausfällen garantieren wir eine Reaktionszeit von maximal 30 Minuten während der Geschäftszeiten (Mo-Fr, 8-18 Uhr). Mit unserem 24/7-Support-Paket erreichen Sie uns rund um die Uhr mit einer garantierten Reaktionszeit von unter 60 Minuten. Unser IT-Notdienst ist auch an Wochenenden und Feiertagen verfügbar."
    },
    {
      question: "Welche Branchen betreut AB-Informatik hauptsächlich?",
      answer: "Wir sind spezialisiert auf mittelständische Unternehmen aus den Bereichen Dienstleistung, Handel, Handwerk, Gesundheitswesen und produzierende Industrie im Raum Siegburg, Bonn und Köln. Typische Kundengrößen liegen zwischen 10 und 150 Mitarbeitern. Besondere Expertise haben wir in regulierten Branchen mit hohen Compliance-Anforderungen (DSGVO, NIS2, ISO 27001)."
    },
    {
      question: "Bietet AB-Informatik auch Cloud-Lösungen an?",
      answer: "Ja, wir bieten umfassende Cloud-Services: Microsoft 365 Migration und Administration, sichere Cloud-Backup-Lösungen, hybride Cloud-Infrastrukturen und Cloud-Telefonie. Dabei setzen wir ausschließlich auf DSGVO-konforme europäische Rechenzentren. Wir beraten Sie neutral zur optimalen Cloud-Strategie für Ihr Unternehmen – ob Public Cloud, Private Cloud oder Hybrid-Lösung."
    },
    {
      question: "Wie schützt AB-Informatik unsere IT vor Cyberangriffen?",
      answer: "Unser Security-Konzept umfasst: mehrschichtige Firewall-Systeme, Endpoint Detection & Response (EDR), regelmäßige Schwachstellenscans, automatisierte Patch-Management, verschlüsselte Backups mit Offline-Kopien, Security-Awareness-Schulungen für Mitarbeiter und 24/7-Security-Monitoring. Zusätzlich führen wir regelmäßige Penetrationstests und NIS2-Compliance-Checks durch."
    },
    {
      question: "Was unterscheidet AB-Informatik von anderen IT-Systemhäusern in der Region?",
      answer: "Als inhabergeführtes IT-Systemhaus mit über 15 Jahren Erfahrung kennen wir die spezifischen Herausforderungen mittelständischer Unternehmen in NRW. Unser Alleinstellungsmerkmal: persönliche Betreuung durch feste Ansprechpartner, transparent kommunizierte Festpreise ohne versteckte Kosten, proaktives Monitoring statt reaktiver Problemlösung und unsere Spezialisierung auf IT-Sicherheit und Compliance. Über 200 zufriedene Kunden vertrauen uns langfristig."
    },
    {
      question: "Übernimmt AB-Informatik auch die Migration unserer bestehenden IT-Systeme?",
      answer: "Ja, wir übernehmen die komplette Migration Ihrer IT-Infrastruktur: Server-Migration (auch von VMware zu Proxmox), Microsoft 365 Migration, E-Mail-Systeme, Datenbanken und Cloud-Migrationen. Dabei garantieren wir minimale Ausfallzeiten durch sorgfältige Planung, Testphasen und Wochenend-Migrationen. Ein detaillierter Migrationsplan mit Risikoanalyse und Rollback-Strategie ist Standard."
    },
    {
      question: "Bietet AB-Informatik IT-Strategieberatung für digitale Transformation an?",
      answer: "Ja, unsere IT-Strategieberatung umfasst: Analyse Ihrer aktuellen IT-Landschaft, Entwicklung einer maßgeschneiderten Digitalisierungs-Roadmap, Technologie-Bewertung und -Auswahl, Budget- und Ressourcenplanung sowie Change-Management-Begleitung. Wir helfen Ihnen, IT-Investitionen zu priorisieren und messbare Business-Ziele zu erreichen. Viele unserer Kunden nutzen dies auch für KI-Integration und Automatisierungsprojekte."
    },
    {
      question: "Wie läuft die Zusammenarbeit mit AB-Informatik ab?",
      answer: "Phase 1: Kostenlose Erstberatung und IT-Infrastruktur-Analyse (ca. 2-3 Stunden). Phase 2: Detailliertes Angebot mit transparenter Preisstruktur und Service Level Agreements (SLAs). Phase 3: Strukturierte Onboarding-Phase mit Dokumentation aller Systeme. Phase 4: Kontinuierliche Betreuung mit monatlichen Reports, regelmäßigen Review-Meetings und proaktiven Optimierungsvorschlägen. Sie haben jederzeit einen festen Ansprechpartner."
    },
    {
      question: "Können wir AB-Informatik auch für kurzfristige IT-Projekte engagieren?",
      answer: "Ja, neben unseren Managed Services bieten wir auch projektbasierte IT-Dienstleistungen an: Netzwerk-Installationen, Server-Setups, Software-Rollouts, IT-Sicherheits-Audits, Interim IT-Management bei Vakanzen und befristete IT-Projekte. Die Abrechnung erfolgt transparent nach Aufwand oder als Festpreis-Projekt. Auch kurzfristige IT-Notfall-Unterstützung ist möglich."
    },
    {
      question: "Ist AB-Informatik auch für kleine Unternehmen mit 5-10 Mitarbeitern geeignet?",
      answer: "Absolut! Wir betreuen Unternehmen jeder Größe – von 5-Personen-Kanzleien bis zu 150-Mitarbeiter-Betrieben. Für kleinere Unternehmen bieten wir flexible Einstiegspakete mit skalierbaren Services, die genau auf Ihre Bedürfnisse zugeschnitten sind. Viele unserer Kunden sind mit uns gewachsen. Auch als kleines Unternehmen profitieren Sie von Enterprise-Level-Security und professionellem IT-Management zu fairen, transparenten Konditionen."
    },
    {
      question: "Welche Zertifizierungen und Partnerschaften hat AB-Informatik?",
      answer: "Wir sind zertifizierter Microsoft Partner, arbeiten mit führenden Technologie-Herstellern wie Cisco, Fortinet und Veeam zusammen und verfassen unsere Sicherheitskonzepte nach ISO 27001 und BSI IT-Grundschutz Standards. Unser Team hält aktuelle Zertifizierungen in den Bereichen IT-Security, Cloud-Administration und Netzwerk-Management. Wir sind außerdem Mitglied im Bundesverband IT-Mittelstand e.V."
    },
    {
      question: "Kann AB-Informatik unsere komplette IT-Infrastruktur übernehmen?",
      answer: "Ja, wir bieten Full-Service IT-Management an und kümmern uns um Ihre gesamte IT-Infrastruktur von A bis Z. Das umfasst: Server und Netzwerk-Infrastruktur, alle Arbeitsplätze und Endgeräte, Cloud-Services und E-Mail-Systeme, Datensicherung und Disaster Recovery, IT-Sicherheit und Compliance, Telefonanlage und VoIP, Software-Lizenzen und Updates sowie den kompletten IT-Support. Sie profitieren von einem zentralen Ansprechpartner für alle IT-Belange, wodurch Sie sich vollständig auf Ihr Kerngeschäft konzentrieren können, während wir die komplette Verantwortung für Ihre IT-Landschaft übernehmen."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section" style={{
      padding: '80px 20px',
      background: 'var(--bg-primary)'
    }}>
      <div className="section-content" style={{ maxWidth: '900px', margin: '0 auto' }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '60px' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 16px',
            background: 'linear-gradient(135deg, rgba(0, 113, 227, 0.1), rgba(0, 168, 255, 0.1))',
            borderRadius: '30px',
            marginBottom: '20px'
          }}>
            <HelpCircle size={20} color="#0071e3" />
            <span style={{
              fontSize: '14px',
              fontWeight: '600',
              color: '#0071e3',
              textTransform: 'uppercase',
              letterSpacing: '1px'
            }}>
              Häufig gestellte Fragen
            </span>
          </div>
          <h2 className="display-large" style={{ marginBottom: '16px' }}>
            Alles was Sie über unsere IT-Services wissen müssen
          </h2>
          <p className="body-large" style={{ color: 'var(--text-secondary)', maxWidth: '700px', margin: '0 auto' }}>
            Antworten auf die wichtigsten Fragen zu IT-Support, Preisen, Sicherheit und unseren Services für Unternehmen in Siegburg, Bonn und Köln.
          </p>
        </div>

        {/* FAQ Items */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          {faqData.map((faq, index) => (
            <div
              key={index}
              style={{
                background: 'var(--bg-secondary)',
                borderRadius: '16px',
                border: '1px solid var(--border-subtle)',
                overflow: 'hidden',
                transition: 'all 0.3s ease'
              }}
            >
              {/* Question */}
              <button
                onClick={() => toggleFAQ(index)}
                style={{
                  width: '100%',
                  padding: '24px',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: '20px',
                  background: 'transparent',
                  border: 'none',
                  cursor: 'pointer',
                  textAlign: 'left'
                }}
              >
                <h3 style={{
                  fontSize: '18px',
                  fontWeight: '600',
                  color: 'var(--text-primary)',
                  margin: 0,
                  lineHeight: '1.5'
                }}>
                  {faq.question}
                </h3>
                <div style={{
                  flexShrink: 0,
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '50%',
                  background: openIndex === index ? '#0071e3' : 'var(--bg-tertiary)',
                  transition: 'all 0.3s ease'
                }}>
                  {openIndex === index ? (
                    <ChevronUp size={20} color="white" />
                  ) : (
                    <ChevronDown size={20} color="var(--text-secondary)" />
                  )}
                </div>
              </button>

              {/* Answer */}
              {openIndex === index && (
                <div style={{
                  padding: '0 24px 24px 24px',
                  animation: 'slideDown 0.3s ease'
                }}>
                  <p style={{
                    fontSize: '16px',
                    lineHeight: '1.7',
                    color: 'var(--text-secondary)',
                    margin: 0
                  }}>
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{
          marginTop: '60px',
          textAlign: 'center',
          padding: '40px',
          background: 'var(--bg-secondary)',
          borderRadius: '16px',
          border: '1px solid var(--border-subtle)'
        }}>
          <h3 style={{
            fontSize: '24px',
            fontWeight: '700',
            color: 'var(--text-primary)',
            marginBottom: '12px'
          }}>
            Noch Fragen?
          </h3>
          <p style={{
            fontSize: '16px',
            color: 'var(--text-secondary)',
            marginBottom: '24px'
          }}>
            Unser Team berät Sie gerne persönlich zu Ihren IT-Anforderungen.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a
              href="tel:+492241261310"
              style={{
                padding: '14px 28px',
                background: 'linear-gradient(135deg, #0071e3, #00a8ff)',
                color: 'white',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'transform 0.2s ease'
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            >
              📞 Jetzt anrufen: +49 2241 261310
            </a>
            <a
              href="#contact"
              style={{
                padding: '14px 28px',
                background: 'var(--bg-tertiary)',
                color: 'var(--text-primary)',
                border: '2px solid var(--border-subtle)',
                borderRadius: '12px',
                fontSize: '16px',
                fontWeight: '600',
                textDecoration: 'none',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '8px',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => e.currentTarget.style.borderColor = '#0071e3'}
              onMouseOut={(e) => e.currentTarget.style.borderColor = 'var(--border-subtle)'}
            >
              ✉️ Kontaktformular
            </a>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </section>
  );
};

export default FAQSection;
